export function pr (str) {
    console.log(str);
}

export default pr;